import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/SectionCard.scss';

const SectionCard = ({ title, description, className, to }) => {
  return (
    <Link to={to} className={`section-card ${className}`}>
      <div>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </Link>
  );
};

export default SectionCard;
